// extracted by mini-css-extract-plugin
module.exports = {"listItemsContainer":"NavigationDrawerBody_listItemsContainer__CsgxD","subtitle":"NavigationDrawerBody_subtitle__3VnPU"};